import { render } from "./doingProject.vue?vue&type=template&id=7f1c1bb8"
import script from "./doingProject.vue?vue&type=script&lang=js"
export * from "./doingProject.vue?vue&type=script&lang=js"

import exportComponent from "/home/webiotcpc/dhruvi/Git/tivo/vue-tivo/tivo-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__